"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALL_PAYWITH_OPTIONS = exports.DEFAULT_PAYWITH_OPTIONS = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledSystem = require("styled-system");

var _Flex = _interopRequireDefault(require("../Flex"));

var _Text = _interopRequireDefault(require("../Text"));

var _excluded = ["mode"];
var BlockText = ( /*#__PURE__*/0, _styledBase["default"])(_Text["default"], {
  target: "e1v438250",
  label: "BlockText"
})("display:block;font-size:inherit;line-height:", (0, _styledSystem.themeGet)('lineHeights.normal'), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1BheVdpdGhCdXR0b25Hcm91cC9wcmltaXRpdmVzLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU84QiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9QYXlXaXRoQnV0dG9uR3JvdXAvcHJpbWl0aXZlcy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgdGhlbWVHZXQgfSBmcm9tICdzdHlsZWQtc3lzdGVtJztcbmltcG9ydCBGbGV4IGZyb20gJy4uL0ZsZXgnO1xuaW1wb3J0IFRleHQgZnJvbSAnLi4vVGV4dCc7XG5cbmNvbnN0IEJsb2NrVGV4dCA9IHN0eWxlZChUZXh0KWBcbiAgZGlzcGxheTogYmxvY2s7XG4gIGZvbnQtc2l6ZTogaW5oZXJpdDtcbiAgbGluZS1oZWlnaHQ6ICR7dGhlbWVHZXQoJ2xpbmVIZWlnaHRzLm5vcm1hbCcpfTtcbmA7XG5cbmNvbnN0IFBheVdpdGhMYWJlbCA9ICh7IG1vZGUsIC4uLnJlc3QgfSkgPT4gKFxuICA8RmxleCB7Li4ucmVzdH0gZmxleERpcmVjdGlvbj1cImNvbHVtblwiPlxuICAgIDxCbG9ja1RleHQ+VXNlPC9CbG9ja1RleHQ+XG4gICAgPEJsb2NrVGV4dCBmb250V2VpZ2h0PVwiYm9sZFwiPnttb2RlfTwvQmxvY2tUZXh0PlxuICA8L0ZsZXg+XG4pO1xuXG5QYXlXaXRoTGFiZWwucHJvcFR5cGVzID0geyBtb2RlOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQgfTtcblxuZXhwb3J0IGNvbnN0IERFRkFVTFRfUEFZV0lUSF9PUFRJT05TID0gW1xuICB7XG4gICAgbGFiZWw6IDxQYXlXaXRoTGFiZWwgbW9kZT1cIkNBU0hcIiAvPixcbiAgICB2YWx1ZTogJ2Nhc2gnLFxuICB9LFxuICB7XG4gICAgbGFiZWw6IDxQYXlXaXRoTGFiZWwgbW9kZT1cIlBPSU5UU1wiIC8+LFxuICAgIHZhbHVlOiAncG9pbnRzJyxcbiAgfSxcbl07XG5cbmV4cG9ydCBjb25zdCBBTExfUEFZV0lUSF9PUFRJT05TID0gW1xuICAuLi5ERUZBVUxUX1BBWVdJVEhfT1BUSU9OUyxcbiAge1xuICAgIGxhYmVsOiA8UGF5V2l0aExhYmVsIG1vZGU9XCJQT0lOVFMgUExVUyBQQVlcIiAvPixcbiAgICB2YWx1ZTogJ3BvaW50c1BsdXNQYXknLFxuICB9LFxuXTtcbiJdfQ== */"));

var PayWithLabel = function PayWithLabel(_ref) {
  var mode = _ref.mode,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], (0, _extends2["default"])({}, rest, {
    flexDirection: "column"
  }), /*#__PURE__*/_react["default"].createElement(BlockText, null, "Use"), /*#__PURE__*/_react["default"].createElement(BlockText, {
    fontWeight: "bold"
  }, mode));
};

PayWithLabel.propTypes = {
  mode: _propTypes["default"].string.isRequired
};
var DEFAULT_PAYWITH_OPTIONS = [{
  label: /*#__PURE__*/_react["default"].createElement(PayWithLabel, {
    mode: "CASH"
  }),
  value: 'cash'
}, {
  label: /*#__PURE__*/_react["default"].createElement(PayWithLabel, {
    mode: "POINTS"
  }),
  value: 'points'
}];
exports.DEFAULT_PAYWITH_OPTIONS = DEFAULT_PAYWITH_OPTIONS;
var ALL_PAYWITH_OPTIONS = [].concat(DEFAULT_PAYWITH_OPTIONS, [{
  label: /*#__PURE__*/_react["default"].createElement(PayWithLabel, {
    mode: "POINTS PLUS PAY"
  }),
  value: 'pointsPlusPay'
}]);
exports.ALL_PAYWITH_OPTIONS = ALL_PAYWITH_OPTIONS;